import { PropsWithChildren } from 'react';

import styles from './PlaygroundWrapper.module.css';

export function PlaygroundWrapper({ children }: PropsWithChildren) {
  return <div className={styles['playground-wrapper']}>{children}</div>;
}
